import Vue from 'vue';
import { EventManager } from '../vue/EventManager.js';
import AOS from 'aos';
import VueRouter from 'vue-router';
import VueLazyload from 'vue-lazyload';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import TestComponent from '../vue/TestComponent.vue';
import SiteHeader from '../vue/SiteHeader.vue';
import MenuButton from '../vue/MenuButton.vue';
import PageHeader from '../vue/PageHeader.vue';
import ScrollButton from '../vue/ScrollButton.vue';
import AnchorList from '../vue/AnchorList.vue';
import ReadingTime from '../vue/ReadingTime.vue';
// import QuickLinks from '../vue/QuickLinks.vue';
import FullWidthBanner from '../vue/FullWidthBanner.vue';
import RichText from '../vue/RichText.vue';
import QuoteSource from '../vue/QuoteSource.vue';
// import VideoButton from '../vue/VideoButton.vue';
// import FeaturedCta from '../vue/FeaturedCta.vue';
import SiteFooter from '../vue/SiteFooter.vue';
import VideoModal from '../vue/VideoModal.vue';
// import AlertBanner from '../vue/AlertBanner.vue';
import MobileMenu from '../vue/MobileMenu.vue';
import PrimaryButton from '../vue/PrimaryButton.vue';
import SubmitButton from '../vue/SubmitButton.vue';
// import SecondaryButton from '../vue/SecondaryButton.vue';
// import TertiaryButton from '../vue/TertiaryButton.vue';
// import AcknowledgementOfCountry from '../vue/AcknowledgementOfCountry.vue';
// import SearchListing from '../vue/SearchListing.vue';
import LoadingAnimation from '../vue/LoadingAnimation.vue';
import BreadCrumbs from '../vue/BreadCrumbs.vue';
// import NotFound from '../vue/NotFound.vue';
import PageDivider from '../vue/PageDivider.vue';
// import HeroHeader from '../vue/HeroHeader.vue';
// import FullWidthBanner from '../vue/FullWidthBanner.vue';
import VideoImage from '../vue/VideoImage.vue';
// import FeaturedContent from '../vue/FeaturedContent.vue';
// import MultiColumn from  '../vue/MultiColumn.vue';
// import MediaAndText from '../vue/MediaAndText.vue';
// import MixedContent from '../vue/MixedContent.vue';
// import ContentSlider from '../vue/ContentSlider.vue';
// import ImageSlider from '../vue/ImageSlider.vue';
// import TestimonialSlider from '../vue/TestimonialSlider.vue';
// import AccordionItem from '../vue/AccordionItem.vue';
// import AccordionWrapper from '../vue/AccordionWrapper.vue';
// import DownloadsLinks from '../vue/DownloadsLinks.vue';
// import FeaturedCtas from '../vue/FeaturedCtas.vue';
import FeaturedPostListing from '../vue/FeaturedPostListing.vue';
import FeaturedPeopleListing from '../vue/FeaturedPeopleListing.vue';
// import FeaturedPeople from '../vue/FeaturedPeople.vue';
import PostListing from '../vue/PostListing.vue';
// import MobilePageSelect from '../vue/MobilePageSelect.vue';
// import TwoThreeImages from '../vue/TwoThreeImages.vue';
// import FeaturedPostListing from '../vue/FeaturedPostListing.vue';
// import Ss3Fullpage from '../vue/Ss3Fullpage.vue';
// import Ss3Loader from '../vue/Ss3Loader.vue';
import FeaturedIconTile from '../vue/FeaturedIconTile.vue';
import FeaturedTile from '../vue/FeaturedTile.vue';
import StayInTouch from '../vue/StayInTouch.vue';

import { gsap } from 'gsap';

import { CustomEase } from 'gsap/CustomEase';
import { RoughEase, ExpoScaleEase, SlowMo } from 'gsap/EasePack';

import { Flip } from 'gsap/Flip';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Observer } from 'gsap/Observer';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
import { TextPlugin } from 'gsap/TextPlugin';
import '../../scripts/jquery.smoothState.js';

gsap.registerPlugin(
  Flip,
  ScrollTrigger,
  Observer,
  ScrollToPlugin,
  MotionPathPlugin,
  TextPlugin,
  RoughEase,
  ExpoScaleEase,
  SlowMo,
  CustomEase,
);

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(VueLazyload);
const router = new VueRouter({ mode: 'history' });

export default {
  init() {
    // JavaScript to be fired on all pages
    let vueArea = document.querySelectorAll('.app');

    let matchingElements = document.getElementsByClassName('vue-disable'),
      hiddenMarkup = [];

    for (var i = 0; i < matchingElements.length; i++) {
      hiddenMarkup.push(matchingElements[i].innerHTML);
      matchingElements[i].innerHTML = '';
    }

    Vue.config.productionTip = false;

    const store = new Vuex.Store({
      state: {
        mobile_menu: false,
        alert_bar_closed: false,
        alert_bar_id: false,
      },
      getters: {},
      mutations: {
        closeAlertBar(state, payload) {
          state.alert_bar_closed = payload;
        },
        alertBarID(state, payload) {
          state.alert_bar_id = payload;
        },
        toggleMobileMenu(state, payload) {
          state.mobile_menu = payload;
        },
      },
      actions: {},
      plugins: [createPersistedState()],
    });

    if (vueArea) {
      vueArea.forEach((element) => {
        new Vue({
          store: store,
          router,
          data: {
            topScrollThreshold: 100,
            isScrolled: false,
            isPageReady: false,
          },

          components: {
            TestComponent,
            MenuButton,
            SiteHeader,
            PageHeader,
            ScrollButton,
            AnchorList,
            ReadingTime,
            QuoteSource,
            // Ss3Loader,
            // Ss3Fullpage,
            // StandardHeader,
            // QuickLinks,
            FullWidthBanner,
            // VideoButton,
            // FeaturedCta,
            FeaturedPostListing,
            // MixedContent,
            SiteFooter,
            VideoModal,
            // AlertBanner,
            MobileMenu,
            PrimaryButton,
            SubmitButton,
            // SecondaryButton,
            // TertiaryButton,
            // AcknowledgementOfCountry,
            // SearchListing,
            LoadingAnimation,
            BreadCrumbs,
            // NotFound,
            PageDivider,
            // HeroHeader,
            // FullWidthBanner,
            RichText,
            VideoImage,
            // FeaturedContent,
            // MultiColumn,
            // MediaAndText,
            // ContentSlider,
            // ImageSlider,
            // TestimonialSlider,
            // AccordionItem,
            // AccordionWrapper,
            // DownloadsLinks,
            // FeaturedCtas,
            // FeaturedPostListing,
            // FeaturedPeople,
            PostListing,
            // MobilePageSelect,
            // TwoThreeImages,
            FeaturedIconTile,
            FeaturedTile,
            FeaturedPeopleListing,
            StayInTouch,
          },

          methods: {
            onRefreshAos: function () {
              AOS.refresh();
            },
            didScroll() {
              var elementTarget = document.querySelector('.site_header');
			        this.isScrolled = window.scrollY > elementTarget.offsetHeight + 100;
              // this.isScrolled = window.scrollY > this.topScrollThreshold;
              this.updateTrigger();
            },

            updateTrigger() {
              var sideNav = document.querySelector(
                '.page-template-template-side_nav',
              );
              var hash = window.location.hash;
              let navAccordion = document.querySelectorAll(
                '.anchored_nav__inner',
              );

              if (hash && sideNav && navAccordion) {
                navAccordion.forEach((element) => {
                  var accordion_content = element.querySelectorAll('ul li');

                  if (accordion_content) {
                    accordion_content.forEach((element) => {
                      let theLink = element.querySelector('a');

                      if (theLink != null) {
                        if (
                          theLink.href.split('#')[1] === hash.replace('#', '')
                        ) {
                          element.classList.add('current');
                        } else {
                          element.classList.remove('current');
                        }
                      }
                    });
                  }
                });
              }
            },
          },

          created() {
            window.addEventListener('scroll', this.didScroll);
            // this.updateTrigger();
          },

          destroyed() {
            window.removeEventListener('scroll', this.didScroll);
          },

          mounted() {
            var self = this;
            setTimeout(function () {
              self.isPageReady = true;
              AOS.init();
            }, 500);

            // eslint-disable-next-line no-unused-vars
            self.$Lazyload.$on(
              'loaded',
              function (
                {
                  bindType,
                  el,
                  naturalHeight,
                  naturalWidth,
                  $parent,
                  src,
                  loading,
                  error,
                },
                formCache,
              ) {
                // Lazy loading images can cause AOS to get out of sync because the loaded image changes the height of the content
                // so refreshing it in order to re-calculate trigger points
                EventManager.$emit('should-refresh-aos');
              },
            );
          },
        }).$mount(element);

        /* Re-Attach exclusions
    ---------------------------------------------------------------------------------------------------- */

        for (var ii = 0; ii < matchingElements.length; ii++) {
          matchingElements[ii].innerHTML = hiddenMarkup[ii];
        }
      });
    }

    $(function () {
      'use strict';
      var options = {
          prefetch: false,
          cacheLength: 0,
          blacklist: '.transition-ignore, #gform_1, #gform_2, #gform_3, #gform_4, #gform_5, #gform_6, #gform_7, #gform_8, #gform_9, .site_button.post',
          locationHeader: 'X-SmoothState-Location',
          onStart: {
            duration: 200, // Duration of our animation
            render: function ($container) {
              // Add your CSS animation reversing class
              $container.addClass('is-exiting');

              // Restart your animation
              smoothState.restartCSSAnimations();
            },
          },
          onReady: {
            duration: 200,
            render: function ($container, $newContent) {
              // Remove your CSS animation reversing class
              $container.removeClass('is-exiting');

              // Inject the new content
              $container.html($newContent);
            },
          },
        },
        smoothState = $('#smooth').smoothState(options).data('smoothState');
    });
  },
  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js